<template>
  <header class="flex items-center w-full h-16 bg-white border-b border-border border-opacity-30 px-2 py-2">
    <slot name="search"></slot>
  </header>
</template>